import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";
import PageProject from "./PageProject";
import SmartLink from "../fragments/SmartLink";

const PageProjects = ({ block }) => {

	const [galleryView, setGalleryView] = useState(true);
	const [fadeOut, setFadeOut] = useState(false);

	const projectHeaderRef = useRef(null);
	const thumbnailVideoRefs = useRef([]);

	const handleResize = useCallback(() => {
		if (projectHeaderRef.current) {
			const height = projectHeaderRef.current.clientHeight;
			document.documentElement.style.setProperty('--project-header-height', `${height}px`);
		}
	}, []);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			handleResize();
		}, 0);

		window.addEventListener('resize', handleResize);
		
		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('resize', handleResize);
		};
	}, [handleResize]);

	useEffect(() => {
		if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const video = entry.target;
					if (entry.isIntersecting) {
						video.play().catch(() => {});
					} else {
						video.pause();
					}
				});
			},
			{ threshold: 0.5 }
		);

		thumbnailVideoRefs.current.forEach((video) => {
			if (video) observer.observe(video);
		});

		return () => observer.disconnect();
	}, [block]);

	const toggleView = (openGallery) => {
		if (openGallery) {
			setFadeOut(true);
			setTimeout(() => {
				setGalleryView(true);
				setFadeOut(false);
			}, 850);
		} else {
			setFadeOut(true);
			setTimeout(() => {
				setGalleryView(false);
				setFadeOut(false);
			}, 850);
		}
	}

    if (!block) return null;

	console.log('Rendering PageProjects with block:', block);

    return (
        <div className={`c-page__block`}>
			<div className={`c-projects`}>
				{block.project && block.project.length > 0 && (
					block.project.map((project, index) => (
						<div className="c-projects__slide" key={index}>
							<div className="c-projects__slide__header">
								<h2 className="c-paragraph" dangerouslySetInnerHTML={{__html: project.title}}></h2>
								<h3 className="c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{__html: project.project_type}}></h3>
							</div>
							<SmartLink
								to={project.url}
								className="c-projects__slide__link"
							>View Project</SmartLink>
							<SmartLink
								to={project.url}
								className="c-projects__slide__image"
							>
								<div className="c-projects__slide__image__inner">
									{project.thumbnail_cinemagraph ? (
										<video
											ref={(el) => thumbnailVideoRefs.current[index] = el}
											className="c-projects__slide__image__video"
											src={project.thumbnail_cinemagraph}
											muted
											loop
											playsInline
											preload="metadata"
										/>
									) : null}
									<Image 
										src={project.thumbnail_src}
										alt={project.title}
									/>
								</div>
							</SmartLink>
						</div>
					))
				)}
					
			</div>
		</div>
	);
};

export default PageProjects;
